<template>
    <base-scroll-container
        class="relative sm:overflow-x-hidden h-full lg:pb-10 scrollbar-track-cloud-dark scroll-smooth flex flex-col justify-between"
    >
        <transition-group
            name="slide-fade"
            :css="isMobile"
        >
            <option-group
                v-for="(group, index) in filteredGroups"
                :key="group"
                :group-data="group"
                :group-index="index"
                :class="{ 'mb-10' : index !== filteredGroups.length - 1 }"
                class="absolute top-0 md:relative sm:pr-2 w-full"
            />
        </transition-group>
    </base-scroll-container>
</template>

<script>
    import allStores from '../stores/all';

    import BaseScrollContainer from './BaseScrollContainer.vue';
    import OptionGroup from './OptionGroup.vue';

    export default {
        mixins: [allStores],

        components: {
            BaseScrollContainer,
            OptionGroup,
        },

        computed: {
            isMobile() {
                return this.appStore.isMobile;
            },

            currentStep() {
                return this.appStore.currentStep;
            },

            allGroups() {
                return this.customizerStore.viewController?.blueprint.groups;
            },

            filteredGroups() {
                return this.getCurrentGroup();
            },
        },

        methods: {
            getCurrentGroup() {
                if (this.allGroups?.length) {
                    // Filter out groups not used for main customization experience (personalization, label)
                    const filteredGroups = this.allGroups.filter((group) => group.custom['oe-hide'] !== 'true');

                    if (this.isMobile && this.currentStep.includes('select')) {
                        const groupName = this.currentStep.split('select')[1];
                        const result = filteredGroups.find((group) => group.name === groupName);

                        return [result];
                    }

                    return filteredGroups;
                }

                return {};
            },
        },
    };
</script>
